import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { LoginService } from '../service/login.service';


@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  public newUser = false;
  public loginForm: FormGroup;
  public show: boolean = false
  public errorMessage: any;

  constructor(
    private fb: FormBuilder,
    public router: Router,
    private authService: LoginService) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  ngOnInit() { }

  login(): void {
    if (this.loginForm.invalid) {
      return Object.values(this.loginForm.controls).forEach((controls) => {
        controls.markAllAsTouched();
      })
    }

    this.authService.login(this.loginForm.value).subscribe((resp) => {
      if (resp.isSuccess) {
        this.router.navigate([''])
      }
    })
  }

  showPassword() {
    this.show = !this.show
  }
}
